<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-row>
      <selectStandardId @updateStandardId="updateStandardId" />
      <el-select
        v-model="eventName"
        size="small"
        filterable
        clearable
        class="w-200px mr-10px ml-10px"
        popper-class="select-tree"
        data-cy="classID"
        ref="tagSelect"
        :placeholder="$t('数据表')"
        @clear="clearTable"
      >
        <el-option :label="classTagName" :value="eventName" hidden> </el-option>
        <el-tree
          ref="tagTree"
          :data="tagTreeData"
          :props="classTreeProps"
          node-key="id"
          @node-click="handleTagTreeClick"
          :default-expanded-keys="typeExpandedKey"
          :current-node-key="typeNodeKey"
          highlight-current
        >
        </el-tree>
      </el-select>
      <!-- <el-input
        class="m-r-10"
        style="width: 180px"
        v-model="eventName"
        size="small"
        placeholder="表名称"
        clearable
      ></el-input> -->
      <el-date-picker
        v-model="startTime"
        size="small"
        class="w-200px mr-10px"
        type="datetime"
        value-format="yyyy-MM-dd HH:mm:ss"
        placeholder="开始日期"
      ></el-date-picker>
      <el-date-picker
        v-model="endTime"
        size="small"
        class="w-200px mr-10px"
        type="datetime"
        value-format="yyyy-MM-dd HH:mm:ss"
        placeholder="结束日期"
      ></el-date-picker>
      <el-select
        class="w-200px mr-10px"
        v-model="taskState"
        placeholder="状态"
        clearable
        size="small"
        @change="searchByCondition"
      >
        <el-option
          v-for="(item, index) in changeState"
          :key="index"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="searchByCondition">{{ $t('search') }}</el-button>
      <el-button @click="reset">{{ $t('reset') }}</el-button>
    </el-row>
    <!-- <el-row class="m-t-10 m-b-10">
      <el-button type="primary" size="small" @click="searchByCondition">搜索</el-button>
      <el-button type="primary" size="small" @click="reset">重置</el-button>
    </el-row> -->
    <el-row class="mt-20px" style="height: calc(100% - 56px)">
      <el-table
        border
        :data="tableData"
        v-loading="tableLoading"
        height="calc(100% - 48px)"
        ref="tableRef"
      >
        <el-table-column
          prop="tableName"
          :label="$t('数据表')"
          width="300"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="jobName"
          :label="$t('任务名称')"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="checkCount"
          :label="$t('稽核数据量')"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="errorCount" :label="$t('异常数据量')" show-overflow-tooltip>
          <template slot-scope="scoped">
            <div :class="[scoped.row.errorCount > 0 ? 'blue' : '']">
              {{ scoped.row.errorCount }}
            </div>
          </template></el-table-column
        >
        <el-table-column
          prop="lastModifiedUser"
          :label="$t('操作人')"
          width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="lastModifiedTime"
          :label="$t('操作时间')"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="状态" prop="checkType" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-for="(item, index) in changeState" :key="index">{{
              scope.row.checkType === item.id ? item.name : ''
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="checkComments"
          label="处理说明"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column :label="$t('operate')" width="150">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.checkType === 0"
              size="mini"
              :disabled="!$hasAccess('update')"
              @click="updateStatus(scope.row)"
              >已处理</el-button
            >
            <el-button size="mini" @click="editDetail(scope.row)">查看</el-button>
            <!-- <el-button
              size="mini"
              @click="toDetail(scope.row)"
              :disabled="!$hasAccess('read') || scope.row.checkType === 0"
              >{{ $t('detail') }}</el-button
            > -->
            <!-- <el-tooltip content="整改">
              <el-button
                type="primary"
                size="small"
                class="iconfont icon-display"
                @click="viewDetail(scope.row)"
              ></el-button>
            </el-tooltip> -->
            <!-- <el-tooltip content="异常数据确认">
              <el-button
                type="primary"
                size="small"
                class="iconfont icon-activation"
                @click="activationDetail(scope.row)"
              ></el-button>
            </el-tooltip> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next"
        :total="recordCount"
      ></el-pagination>
    </el-row>
    <!-- 整改记录弹窗 -->
    <el-dialog
      :title="$t('整改记录')"
      :visible.sync="rectificationDialog"
      :close-on-click-modal="false"
      width="1400px"
    >
      <el-table
        :data="rectificationDataList"
        border
        ref="rectification"
        stripe
        :height="500"
        row-key="id"
        v-loading="dataLoading"
      >
        <el-table-column label="整改时间" align="center" prop="lastModifiedTime"></el-table-column>
        <el-table-column label="整改项" align="center" prop="classAttributeName"></el-table-column>
        <el-table-column label="整改前" align="center" prop="beforeValue"></el-table-column>
        <el-table-column label="整改后" align="center" prop="afterValue"></el-table-column>
      </el-table>
      <el-pagination
        class="m-t-20 p-t-10 r"
        background
        @current-change="recordChange"
        @size-change="recordSizeChange"
        :current-page.sync="change.pageNo"
        :page-size="change.pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next"
        :total="change.recordCount"
      ></el-pagination>
    </el-dialog>

    <!-- 异常数据确认 -->
    <el-dialog
      title="异常数据确认"
      :visible.sync="abnormalDialog"
      :close-on-click-modal="false"
      width="1400px"
      class="errData"
      height="1200"
    >
      <el-table
        :data="sourceDataList"
        v-loading="listLoading"
        border
        height="400px"
        ref="multipleTable"
        stripe
        row-key="id"
        @selection-change="selectChange"
        @row-click="showRemark"
        class="error-table-box"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column
          align="center"
          v-for="(item, index) in tableHeader"
          show-overflow-tooltip
          :key="index"
          :label="item.name"
        >
          <template slot-scope="scope">
            <el-popover
              placement="bottom"
              trigger="hover"
              v-if="scope.row.dataValueDtos[index].errValueList.length !== 0"
            >
              <ul>
                <li
                  v-for="(item, index) in scope.row.dataValueDtos[index].errValueList"
                  :key="index"
                  class="tc"
                >
                  {{ item }}
                </li>
              </ul>
              <div slot="reference">
                <div
                  :class="{
                    'error-tips': true,
                    'border-red':
                      scope.row.dataValueDtos[index].errValueList.length !== 0 &&
                      !scope.row.dataValueDtos[index].afterValue,
                  }"
                >
                  <!-- 这儿使用template包裹是为了尽可能的不改变element-ui已封装好的样式能够作用到重新渲染的节点上 -->
                  <template v-if="scope.row.dataValueDtos[index].afterValue === ''">
                    {{ scope.row.dataValueDtos[index].beforeValue }}
                  </template>
                </div>
              </div>
            </el-popover>
            <!-- 这儿使用template包裹是为了尽可能的不改变element-ui已封装好的样式能够作用到重新渲染的节点上 -->
            <template v-else>
              {{ scope.row.dataValueDtos[index].beforeValue }}
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-pagination
          class="m-t-20 p-t-10 r abnormalPage"
          background
          @current-change="abnormalDataWay"
          @size-change="abnormalDataSizeChange"
          :current-page.sync="abnormalDataChange.pageNo"
          :page-size.sync="abnormalDataChange.pageSize"
          :page-sizes="$pageSizeAll"
          layout="total, sizes, prev, pager, next"
          :total="abnormalDataChange.recordCount"
        ></el-pagination>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="3">
          <div class="theReason">确认为正常数据的原因</div>
        </el-col>
        <el-col :span="21">
          <el-input
            filterable
            class="w-full"
            size="small"
            :row="2"
            type="textarea"
            placeholder="请输入"
            v-model="correctCause"
            clearable
          ></el-input>
        </el-col>
      </el-row>
      <el-row>
        <div class="fieldFooter">
          <el-button type="primary" size="small" @click="abnormalDataValidation">确认</el-button>
          <el-button type="primary" size="small" @click="abnormalDataCancel">取消</el-button>
        </div>
      </el-row>
    </el-dialog>

    <!-- 处理说明 -->
    <el-dialog
      title="处理说明"
      :visible.sync="illustrateDialog"
      :close-on-click-modal="false"
      class="mini-dialog"
      v-dialogDrag
    >
      <div>
        <el-input
          type="textarea"
          v-model="handleIllustrate"
          clearable
          size="small"
          :rows="10"
          placeholder="第三方系统已处理"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" @click="illustrateSave()">保存</el-button>
        <el-button @click="illustrateDialog = false"> 取消 </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>
<script>
import stdClassListService from '@/services/stdClassListService'
import StandardManagementService from '@/services/thApi/StdClassDataBatch'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'dataRectification',
  components: {
    selectStandardId,
  },
  data() {
    return {
      illustrateDialog: false,
      handleIllustrate: '',
      startTime: null,
      endTime: null,
      arr: [],
      taskRunId: '',
      classId: '',
      abnormalDataChoose: [],
      abnormalDialog: false,
      tableLoading: false,
      correctCause: null, // 确实为正常的原因
      sourceDataList: [],
      tableHeader: [], // 表头数据
      listLoading: false,
      taskState: 0, // 任务状态
      dataLoading: false,
      bnormalDataLoading: false,
      abnormalDataList: [], // 异常数据确认
      rectificationDataList: [], // 整改记录数据
      rectificationDialog: false,
      standardLibrary: localStorage.getItem('standardId'),
      change: {
        pageNo: 1,
        pageSize: 15,
        recordCount: 0,
      },
      abnormalDataChange: {
        pageNo: 1,
        pageSize: 15,
        recordCount: 0,
      },
      eventName: '',
      pageNo: 1,
      pageSize: 15,
      recordCount: 0,
      loading: {
        table: false,
      },
      changeState: [
        { id: 0, name: '未处理' },
        // { id: 1, name: '已提交整改' },
        { id: 2, name: '已处理' },
        // { id: 3, name: '提交整改不同意,需要重新整改' },
      ],
      tableData: [],
      currentErrorItem: null,
      tagTreeData: [],
      classTreeProps: { label: 'name', children: 'children' },
      typeNodeKey: '', // 类别默认选中的节点
      typeExpandedKey: [], // 类别默认展开的节点
      classTagName: '',
      currentRow: {},
    }
  },
  computed: {
    // tableHeighht() {
    //   debugger
    //   return `${window.innerHeight - 250}px`
    // },
  },
  watch: {
    standardLibrary(newVal) {
      if (newVal) {
        this.eventName = ''
        this.classTagName = ''
        this.getTypeList()
        this.getList()
      }
    },
  },
  methods: {
    // 保存处理说明
    async illustrateSave() {
      const formData = new FormData()
      formData.append('checkComments', this.handleIllustrate)
      const res = await StandardManagementService.updateStatus(
        this.currentRow.taskRunRecordId,
        formData
      )
      if (!res) {
        this.$message.success('已处理成功')
        this.searchByCondition()
        this.illustrateDialog = false
      }
    },
    // 修改状态
    async updateStatus(row) {
      this.currentRow = row
      this.handleIllustrate = ''
      this.illustrateDialog = true
    },
    updateStandardId(val) {
      this.standardLibrary = val
    },
    clearTable() {
      this.eventName = ''
      this.classTagName = ''
      this.typeNodeKey = ''
      this.typeExpandedKey = []
      this.$nextTick(() => {
        this.$refs.tagTree.setCurrentKey(null) // 取消当前高亮节点
      })
    },
    toDetail(row) {
      this.$router.push(
        `./rectification-details?id=${row.taskRunRecordId}&classId=${row.stdClassId}`
      )
    },
    handleTagTreeClick(node) {
      this.eventName = node.id
      this.classTagName = node.name
      this.$refs.tagSelect.blur()
    },
    // 获取对象类别列表
    async getTypeList() {
      const parameter = {
        standard_id: this.standardLibrary,
        data_type: 1,
        approve_status: 1, // 已发布的实体
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        // this.typeList = res.data
        this.tagTreeData = res.data.length > 0 ? this.listToTree(res.data) : []
      }
    },
    // 列表转树
    listToTree(list) {
      const result = list.reduce((prev, curr, i, arr) => {
        curr.pathName = `/${curr.name}/`
        curr.children = arr.filter((v) => {
          return v.parentId === curr.id
        })
        if (
          curr.parentId === '00000000-0000-0000-0000-000000000000' ||
          curr.parentId === '' ||
          curr.parentId === null
        ) {
          prev.push(curr)
        }
        return prev
      }, [])
      return result
    },
    backTo() {},
    showRemark(row) {
      this.correctCause = row.cause
    },
    // 获取异常数据列表
    async getErrorDataList(row) {
      this.classId = row.classId
      this.taskRunId = row.taskRunId
      this.currentErrorItem = row
      this.listLoading = true
      const res = await StandardManagementService.getErrorDetail({
        pageno: this.abnormalDataChange.pageNo,
        pageSize: this.abnormalDataChange.pageSize,
        task_run_id: row.taskRunId,
        class_id: row.classId,
      })
      this.listLoading = false
      if (res && res.data && res.code === 0) {
        if (!res.data.data) {
          this.listLoading = false
          this.$message.warning('整改数据已更新，请查看新数据')
          return
        }
        this.tableHeader = res.data.data.titler
        this.sourceDataList = res.data.data.data
        this.$nextTick(() => {
          _.forEach(this.sourceDataList, (item) => {
            if (item.isWhite === 1) {
              this.$refs.multipleTable.toggleRowSelection(item)
            }
          })
        })
        this.abnormalDialog = true
        this.abnormalDataChange.recordCount = res.page.recordCount
      }
    },
    // 通过条件进行搜索
    searchByCondition() {
      this.getList()
    },
    selectChange(val) {
      this.abnormalDataList = val
    },
    // 搜索重置
    reset() {
      // this.standardLibrary = ''
      this.eventName = ''
      this.classTagName = ''
      this.startTime = null
      this.endTime = null
      this.searchByCondition()
      // this.taskState = ''
      // this.handleSizeChange()
    },
    // 查看详情
    async viewDetail(data) {
      const params = {
        task_run_id: data.taskRunId,
        class_id: data.classId,
        pageno: this.change.pageNo,
        pageSize: this.change.pageSize,
      }
      const res = await StandardManagementService.getRRecords(params)
      if (res && res.code === 0) {
        this.rectificationDataList = res.data.data
        this.change.recordCount = res.page.recordCount
      }
      this.rectificationDialog = true
    },
    // 当前分页改变
    handleCurrentChange() {
      this.getList()
    },

    // 当页数量改变
    handleSizeChange() {
      this.pageNo = 1
      this.getList()
    },
    // 获取表数据
    async getList() {
      this.tableLoading = true
      const params = {
        pageIndex: this.pageNo,
        pageSize: this.pageSize,
        // source_id: '',
        stdClassId: this.eventName,
        standardId: this.standardLibrary,
        startTime: this.startTime,
        endTime: this.endTime,
      }
      if (this.taskState !== '') {
        params.checkType = this.taskState
      } else {
        params.checkType = -1 // checkType = -1 查全部
      }
      const res = await StandardManagementService.getDataReceptionDataList(params)
      this.tableLoading = false
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.tableData = res.data
        this.recordCount = res.totalCount
        this.$nextTick(() => {
          this.$refs.tableRef && this.$refs.tableRef.doLayout()
        })
      } else {
        this.tableData = []
        this.recordCount = 0
      }
    },
    // 数据整改编辑
    editDetail(row) {
      this.$router.push({
        path: './error-detail',
        query: {
          task_run_id: row.taskRunRecordId,
          class_id: row.stdClassId,
        },
      })
    },
    // 数据整改确认
    async activationDetail(row) {
      await this.getErrorDataList(row)
    },
    recordChange() {
      this.viewDetail()
    },
    recordSizeChange(data) {
      this.change.pageSize = data
      this.viewDetail()
    },
    abnormalDataWay() {
      if (this.currentErrorItem) {
        this.getErrorDataList(this.currentErrorItem)
      }
    },
    abnormalDataSizeChange() {
      // this.abnormalDataChange.pageSize = val
      if (this.currentErrorItem) {
        this.getErrorDataList(this.currentErrorItem)
      }
    },
    async abnormalDataValidation() {
      const data = []
      _.forEach(this.abnormalDataList, (item) => {
        const arr = {
          ClassId: this.classId,
          TaskRunId: this.taskRunId,
          ClassAttributeId: '',
          DataPrimaryKey: '',
          Cause: this.correctCause,
        }
        arr.DataPrimaryKey = item.dataPrimaryKey
        if (item.dataValueDtos.length > 0) {
          _.forEach(item.dataValueDtos, (o) => {
            if (o.errValueList.length > 0) {
              arr.ClassAttributeId = o.classAttributeId
              data.push(arr)
            }
          })
        }
      })
      const res = await StandardManagementService.abnormalDataConfirm(data)
      if (res && res.code === 0) {
        this.$message.success(res.msg)
        this.abnormalDialog = false
      } else {
        this.$message.warning(res.msg)
      }
    },
    abnormalDataCancel() {
      this.correctCause = ''
      this.abnormalDataChange.pageNo = 1
      this.abnormalDataChange.pageSize = 15
      this.abnormalDataChange.recordCount = 0
      this.sourceDataList = []
      this.abnormalDialog = false
    },
  },
  async created() {
    if (this.standardLibrary) {
      await this.getTypeList() // 获取数据表结构
      this.getList()
    }
  },
  activated() {
    this.standardLibrary = localStorage.getItem('standardId')
  },
}
</script>
<style scoped lang="scss">

/deep/.icon-left:before {
  margin-right: 5px !important;
}
/deep/.el-dialog__body {
  overflow: hidden;
}
.theReason {
  font-weight: 700;
}
.fieldFooter {
  text-align: center;
  margin: 20px 0px;
}
.abnormalPage {
  margin: 10px 0px;
}
// /deep/.el-table__row {
//   height: 60px !important;
// }

/deep/.errData .el-table__row {
  height: 30px !important;
}
.tips {
  position: absolute;
  width: 200px;
  height: 30px;
  background-color: red;
  z-index: 9 !important;
  border: 1px solid rgb(252, 252, 252);
  top: 0;
  right: 30px;
  line-height: 30px;
}
.start {
  position: absolute;
  border-top: 10px solid transparent;
  display: inline-block;
  border-bottom: 10px solid transparent;
  border-right: 10px solid red;
  border-left: 10px solid transparent;
  left: -20px;
  top: 5px;
  z-index: 200 !important;
}
/deep/.el-popper {
  width: 20px;
  right: 0;
  top: 0;
  background-color: red;
}
.errData /deep/.el-dialog {
  height: 700px !important;
}
/deep/.errData.el-dialog__body {
  padding: 10px 10px;
}

.error-table-box {
  /deep/.el-table tr {
    height: 36px;
  }

  /deep/ .el-table__row td {
    // margin: 0;
    // padding: 0;
    .cell {
      height: 36px;
      line-height: 36px;
      // padding: 0;
      // margin: 0;

      span:first-child {
        display: inline-block;
        width: 100%;
        height: 100%;

        .el-popover__reference {
          height: 100%;

          * {
            border-color: red;
          }
        }
      }
    }
  }

  .error-tips {
    width: 100%;
    height: 100%;
    // padding: 2px;

    /deep/ .el-input {
      height: 100%;

      .el-input__inner {
        height: 100%;
      }
    }
  }

  /deep/ .el-table .cell {
    line-height: 36px;
  }

  .border-red {
    border: 1px solid red;
  }

  /deep/ .el-checkbox {
    width: 14px;
    height: 14px;
  }
}
.blue {
  color: #0086f7;
  text-decoration: underline;
}

</style>
